import React from "react";
import { Table } from "semantic-ui-react";
import FilaTareas from "./tablaTareas/FilaTareas";

function TablaContactos(props) {
  return (
    <Table selectable>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell content="Creación" />
          <Table.HeaderCell content="Limite" />
          <Table.HeaderCell content="Descripción" />
          <Table.HeaderCell content="Acciones" />
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {props.datos.map(tarea => (
          <FilaTareas
            key={tarea.id}
            datos={tarea}
            handleBorrarItem={props.handleBorrarTarea}
            handleEditItem={props.handleEditTarea}
            handleCompletarTarea={props.handleCompletarTarea}
          />
        ))}
      </Table.Body>
    </Table>
  );
}

export default TablaContactos;



// WEBPACK FOOTER //
// ./src/pages/ventas/ventasNuevaTarea/TablaTareas.jsx